import { resolveAttorneyStatusOption } from "../../../lib/systemData"
import { isLightColor } from "../../../lib/script"
import classesCell from './BodyCell.module.css'
// import classes from './AttyStatusBox.module.css'

const AttyStatusBox = ({data, group}) => {

    const item = resolveAttorneyStatusOption(data, true);
    const label = item ? item.label : null;
    const color = (group && group.status ? group.status.color : null) ?? item?.color ?? null;

    let bkColor = null;
    let textColor = null;

    const colorCode = (group && group.status && group.status.color_code) ? group.status.color_code : item?.color_code;
    if (colorCode) {
        bkColor = colorCode;
        const lightDark = isLightColor(colorCode);
        textColor = lightDark ? 'var(--text)' : 'var(--white)';
    } else {
        textColor = null;
        bkColor = null;
    }


    // old code
    // const [label, setLabel] = useState(null)
    // const [color, setColor] = useState(null)
    // const [textColor, setTextColor] = useState(null)

    // const [bkColor, setBkColor] = useState(null)

    // useEffect(() => {
    //     let options = attorneyStatusesOptions()

    //     if (options) {
    //         let item = options.find(item => item.value == data)
    //         if (item) {
    //             setLabel(item.label)
    //         }

    //     }
    // }, [data])


    // useEffect(() => {
    //     if (group && group.status) {
    //         setColor(group.status.color)            
    //     }

    //     if (group && group.status &&  group.status.color_code) {
    //         setBkColor(group.status.color_code)
    //         let lightDark = isLightColor(group.status.color_code)
    //         setTextColor(lightDark ? 'var(--text)' : 'var(--white)')
            
    //     } else {
    //         setTextColor(null)
    //         setBkColor(null)
    //     }
    // }, [group])
    return <div style={{backgroundColor: bkColor, color: textColor}} className={`${classesCell.body_cell} ${color ? color+'_attorney' : ''}`}>{label && label}</div>
}

export default AttyStatusBox